<div class="statistics-item" (click)="onItemClicked()" [ngClass]="['statistics-item--aspect-ratio-' + aspectRatio]">
  <div class="statistics-item__image" *ngIf="data.image">
    <brt-image [image]="data.image"></brt-image>
  </div>
  <div class="statistics-item__color-dot" *ngIf="data.color && data.color.length > 0" [ngStyle]="{'background-color': data.color}"></div>

  <div class="statistics-item__title" [innerHTML]="data.title"></div>

  <div class="statistics-item__value-wrapper" [ngClass]="['statistics-item__value-wrapper--difference-' + data.differencePosition]">
<!--    <div class="statistics-item__value-difference"  [ngClass]="{'positive': data.difference > 0, 'negative': data.difference < 0}">-->
<!--      <span class="statistics-item__value-difference-arrow-up">↑</span><span class="statistics-item__value-difference-arrow-down">↓</span> {{data.difference| number}}%-->
<!--    </div>-->

    <div class="statistics-item__value">{{data.value}}{{data.valueUnit}} {{data.valueSuffix}}</div>
  </div>
</div>
